import { Card } from '@ovotech/element-v5';
import styled from 'styled-components';
import { mqMediumUp } from '@/src/utils/mediaQuery';

export const DesktopContainer = styled(Card)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 0;
  padding: 0;
  border: none;
  outline: none;
`;

export const KiaMobileContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: none;
  outline: none;

  img {
    border-radius: 4px;
    width: 260px;
  }
`;

export const KiaLeftContent = styled.div`
  display: none;
  margin: 0;
  padding: 0;
  position: relative;
  img {
    width: 150px;
  }
  ${mqMediumUp(`
    img {
      width: 240px;
    }
    width: 33%;
    display: inline-block;
  `)}
`;

export const KiaRightContent = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  ${mqMediumUp(`
    width: 66%;
  `)}
`;
